var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value !== undefined)?_c('span',{staticClass:"resulticon",class:_vm.getColor},[_vm._v(" "+_vm._s(_vm.getText)+" "),_c('div',{staticClass:"toggle-tooltip"},[_vm._v(" "+_vm._s(_vm.getTextToolTip)+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }